import { axios } from '@ben/api/axios';
import { useInvalidateEmployerEmployeeProfileBenefit } from '@ben/shared/hooks/queries/use-query-employer-employee-profile-benefit';
import { useMutation, type MutateOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

interface EmployerCalculatedPayload {
  enrollmentId: string;
  fieldId: string;
  data: unknown;
  signal?: AbortSignal;
}

export const getEmployerCalculatedValue = async ({
  enrollmentId,
  fieldId,
  data,
  signal,
}: EmployerCalculatedPayload) => {
  const response = await axios.post(
    `ecc/v1.0/benefits/enrolments/${enrollmentId}/calculated-value-field/${fieldId}/recalculate/`,
    data,
    { signal }
  );
  return response?.data;
};

export const useMutationGetEmployerCalculatedValue = (
  enrollmentId: string,
  data: unknown,
  options?: MutateOptions<unknown, AxiosError, string>
) => {
  const invalidateEmployerEmployeeProfileBenefit =
    useInvalidateEmployerEmployeeProfileBenefit();

  return useMutation<unknown, AxiosError, string>({
    mutationFn: (fieldId: string) =>
      getEmployerCalculatedValue({ enrollmentId, fieldId, data }),
    ...options,
    onSuccess: (data, variables, context) => {
      void invalidateEmployerEmployeeProfileBenefit(enrollmentId);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
